import React from "react";
import { TerminalIcon, UsersIcon } from "@heroicons/react/solid";
import { testimonials } from "../data";

export default function Testimonials() {
  return (
    <section id="testimonials">
      <div className="container px-5 py-10 mx-auto text-center">
        <UsersIcon className="w-10 inline-block mb-4" />
        <h1 className="sm:text-4xl text-3xl font-medium title-font text-white mb-4 project-title">
          Depoimentos
        </h1>
        <div className="flex flex-wrap m-4">
          {testimonials.map((project) => (
            <div className="p-4 md:w-1/2 w-full" key={project.title}>
              <div className="h-full bg-gray-500 bg-opacity-40 p-3 rounded">
                <TerminalIcon className="block w-8 text-white-500 mb-4" />
                <p className="leading-relaxed mb-6">{project.description}</p>
                <div className="inline-flex items-center text-white">
                  <img
                    alt="project"
                    src={project.image}
                    className="w-12 rounded-full flex-shrink-0 object-cover object-center"
                  />
                  <span className="flex-grow flex flex-col pl-4">
                    <span className="title-font font-medium text-white">
                      {project.name}
                    </span>
                    <span className="text-white-500 text-sm uppercase">
                      {project.quote}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Testimonials.js